export default {
    GET_LIST: '/manage/message/getMessageList',
    SEND_MESSAGE: '/manage/message/add',
    GET_DETAIL: '/manage/message/detail',
    GET_RECEIVED_LIST: '/manage/message/getSimpleMessageList'
  }


// WEBPACK FOOTER //
// ./src/axios/api_urls/message.js